<template>
    <div class="wcst-game">
        <div class="wcst-container">
            <div class="wcst-category" data-category="1" data-card="111"></div>
            <div class="wcst-category" data-category="2" data-card="222"></div>
            <div class="wcst-category" data-category="3" data-card="333"></div>
            <div class="wcst-category" data-category="4" data-card="444"></div>
        </div>
        <div class="wcst-container">
            <div class="wcst-wrong hidden"></div>
            <div class="wcst-card" data-card="111"></div>
            <div class="wcst-correct hidden"></div>
        </div>
        <div class="wcst-container">
            <span class="help-text">Welke van de 4 plaatjes is de juiste?</span>
        </div>
        <!-- <img class="wcst-card" data-card="111"/> -->
        <!-- <div v-show="gameEnded" class="continue-button-overlay">
            <span @click.prevent="$emit('next')" class="continue-button">Verder ></span>
        </div> -->
    </div>
</template>

<script>
import Backend from '../../../services/Backend';
import Audio from '../../../services/Audio';

let RULES = Object.freeze([
    { shape: true },
    { count: true },
    { color: true }
]);

let CARDS = Object.freeze([
    323, 134, 241, 424, 144, 442, 234, 333, 
    113, 322, 332, 124, 132, 221, 123, 411, 
    223, 224, 443, 344, 212, 133, 232, 312, 
    423, 222, 343, 321, 341, 143, 211, 313, 
    122, 331, 214, 231, 414, 342, 114, 433, 
    444, 314, 213, 244, 112, 422, 141, 324, 
    243, 421, 121, 233, 434, 311, 432, 111, 
    131, 431, 242, 413, 412, 334, 441, 142
].map(c => ({
    index: c,
    color: (c / 100 | 0) % 10, 
    shape: (c / 10 | 0) % 10, 
    count: (c / 1 | 0) % 10 
})));

let CATEGORY_SIZE = 5;
let CATEGORY_MAX_COUNT = 3;

export default {
    'props': {
        data: {}
    },
    data()
    {
        return {
            results: null,
            $game: null,
            $card: null,
            $wrong: null,
            $correct: null,
            $categories: null,
            ruleIndex: null,
            cardIndex: null,
            currentStreak: null,
            prevChosenRule: null,
            gameEnded: false,
        }
    },
    'watch': {
        data: {
            handler() {
            }
        }
    },
    'methods': {
        'onClick': function(event) {
            this.$categories.off('click', this.onClick);
            
            console.log('choice', Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalCards').id);

            let card = this.getCard();
            let rule = this.getRule(this.ruleIndex);
            let category = $(event.target).data('category');
            console.log(card, rule, category, this.isCorrect(rule, card, category));

            let correct = this.isCorrect(rule, card, category);
            
            // Total cards //
            this.results.totalCards += 1;

            if (correct) {            
                // Total correct //
                this.results.totalCorrect += 1;
                
                this.currentStreak += 1;
                this.$correct.removeClass('hidden');
                Audio.playSFX('answer-good');
            } else {
                // Preseverative responses //
                let prevRule = this.getRule(this.ruleIndex - 1);
                if (prevRule !== undefined && this.isCorrect(prevRule, card, category)) {
                    this.results.perseverativeResponses += 1;
                }

                // Presevarative errors //
                if (this.prevChosenRule !== undefined && this.isCorrect(this.prevChosenRule, card, category)) {
                    this.results.perseverativeErrors += 1;
                }

                // Failed to maintain streak //
                if (this.currentStreak >= 5) {
                    this.results.faildToMaintainStreakOf5 += 1;
                }

                // Total errors //
                this.results.totalErrors += 1;

                this.currentStreak = 0;
                this.$wrong.removeClass('hidden');
                Audio.playSFX('answer-wrong');
            }

            // Matches in streak //
            if (this.currentStreak >= 3) {
                if (this.currentStreak == 3) {
                    this.results.matchesInStreakOf3 += 3;
                } else {
                    this.results.matchesInStreakOf3 += 1;
                }
            }
    
            // Total catagories && attempts first catagory //
            if (this.currentStreak == CATEGORY_SIZE) {
                if (this.results.attemptsFirstCatagory == 0) {
                    this.results.attemptsFirstCatagory = this.cardIndex + 1;
                }

                this.results.totalCatagories += 1;

                this.ruleIndex += 1;
                this.currentStreak = 0;
            }

            this.prevChosenRule = {
                shape: card.shape == category,
                color: card.color == category,
                count: card.count == category
            }

            console.table(this.results)

            setTimeout(() => { 
                this.$correct.addClass('hidden');
                this.$wrong.addClass('hidden');

                if (!this.isFinished()) {
                    this.$categories.on('click', this.onClick);
                    this.cardIndex += 1;
                    this.updateCard();
                } else {
                    this.finished();
                }
            }, 1200)
        },
        'isCorrect': function(rule, card, category) {
            return (rule.shape && card.shape == category) ||
                (rule.color && card.color == category) ||
                (rule.count && card.count == category);
        },
        'isFinished': function() {
            return this.results.totalCatagories === CATEGORY_MAX_COUNT;
        },
        'finished': function() {
            this.$emit('complete', true);
            this.$emit('answer', { 
                questionId: this.data[0].question.id, 
                answerParts: [ 
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalCards').id, answerPart: this.results.totalCards + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalErrors').id, answerPart: this.results.totalErrors + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalCorrect').id, answerPart: this.results.totalCorrect + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalCatagories').id, answerPart: this.results.totalCatagories + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'perseverativeErrors').id, answerPart: this.results.perseverativeErrors + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'perseverativeResponses').id, answerPart: this.results.perseverativeResponses + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'matchesInStreakOf3').id, answerPart: this.results.matchesInStreakOf3 + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'attemptsFirstCatagory').id, answerPart: this.results.attemptsFirstCatagory + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'faildToMaintainStreakOf5').id, answerPart: this.results.faildToMaintainStreakOf5 + '' },
                ] 
            });

            console.table('result', this.results);
            this.gameEnded = true;
        },
        'updateCard': function() {
            this.$card.attr('data-card', this.getCard(this.cardIndex).index);
        },
        'getCard': function() {
            return CARDS[this.cardIndex % CARDS.length];
        },
        'getRule': function(index) {
            return index >= 0 ? RULES[index % RULES.length] : undefined;
        }
    },
    mounted() {
        this.results = Object.seal({
            totalCards: 0,
            totalErrors: 0,
            totalCorrect: 0,
            totalCatagories: 0,

            perseverativeErrors: 0,
            perseverativeResponses: 0,

            matchesInStreakOf3: 0,
            attemptsFirstCatagory: 0,
            faildToMaintainStreakOf5: 0,
        });

        this.$game = $(this.$el);

        this.$card    = this.$game.find('.wcst-card');
        this.$wrong   = this.$game.find('.wcst-wrong');
        this.$correct = this.$game.find('.wcst-correct');

        this.$categories = this.$game.find('.wcst-category');

        this.ruleIndex = 0;
        this.cardIndex = 0;
        this.currentStreak = 0;

        this.prevChosenRule = undefined;

        this.$categories.on('click', this.onClick);

        this.updateCard();
    }
}
</script>

<style lang="sass">
    .wcst-game {
        display: flex;
        flex-direction: column;
        justify-content: center;

        width: 100vw;
        height: calc(100vh - 58px);
        padding-top: 58px;

        // background-image: url('images/games/card-sorting/background.png'); 
        // background-position: center;
        // background-size: cover;

        //background: black;
    }
    .wcst-container {
        flex: 1 1 auto;

        max-height: 600px;

        display: flex;
        justify-content: space-around;

        .help-text {
            align-self: center;
            //text-transform: none;
            color: #f0f;
        }
    }
    .wcst-correct {
        flex: 1 1 auto;
        
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('images/games/card-sorting/correct.png');

        &.hidden { background: transparent; }
    }
    .wcst-wrong {
        flex: 1 1 auto;
        
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('images/games/card-sorting/wrong.png');

        &.hidden { background: transparent; }
    }
    .wcst-category {
        @extend .wcst-card;

        margin: 2%;
        cursor: pointer;
    }
    .wcst-card {
        flex: 1 1 auto;
        position: relative;

        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        @for $color from 1 through 4 {
            &[data-card^='#{$color}']::before { background-image: url('images/games/card-sorting/#{$color * 100}.png');}
            @for $shape from 1 through 4 {
                @for $count from 1 through 4 {
                    $card: $color * 100 + $shape * 10 + $count;
                    &[data-card='#{$card}'] { background-image: url('images/games/card-sorting/#{$card}.png'); }
                }
            }
        }

        &::before {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            content: '';

            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
</style>
